import React, { useContext, useState, useEffect } from 'react'
import { AuthContext } from '../../Api/firebase'
import { getTeamLogo } from '../../Utils'
import { BtnCon } from './styles'
import { TeamBasic } from '../../Api/Teams/team.types'
import { Img } from '../Image/Img'

type FavoriteTeamProps = {
  team: TeamBasic
  updateFavTeam: (team: string) => void
}

export const TeamButton: React.FC<React.PropsWithChildren<FavoriteTeamProps>> = ({ team, updateFavTeam }) => {
  const { isAnonymous, isLoggedIn, favTeam } = useContext(AuthContext)!
  const [favorited, setFavorited] = useState<boolean>(false)

  useEffect(() => {
    if (isAnonymous || !favTeam) return
    if (team.fullName.toLowerCase() === favTeam) {
      setFavorited(true)
    }
  }, [isLoggedIn, favTeam])

  return (
    <BtnCon
      favorited={favorited}
      onClick={() => updateFavTeam(team.fullName.toLowerCase())}
    >
      <Img src={getTeamLogo(team.officialId)} alt={`${team.fullName} logo`}/>
      <p>{`${team.location} `}{team.fullName}</p>
    </BtnCon>
  )
}
